export class DashboardMetStationHtml {
    metstation () {
        return `
            <div class="container-layout d-grid grid-2">

                <!-- ✅ MET STATION SIGNAL VALUES (LARGE TABLE) -->
                <div class="container-column grow-col-2">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Met Stations - Signal Values</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body signal-values">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <thead>
                                    <tr>
                                        <th colspan="2"></th>
                                        <th>MET 01</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr data-metric="Irradiance POA 1">
                                        <td>Irr. POA 1</td>
                                        <td class="text-right">W/m2</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Temperature POA 1">
                                        <td>Temp. POA 1</td>
                                        <td class="text-right">°C</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Horizontal Irradiance">
                                        <td>Hor. Irr.</td>
                                        <td class="text-right">W/m2</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="WP Module Temperature">
                                        <td>Mod Temp. 1</td>
                                        <td class="text-right">°C</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Ambient Temperature">
                                        <td>Amb. Temp.</td>
                                        <td class="text-right">°C</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Relative Humidity">
                                        <td>Humidity</td>
                                        <td class="text-right">%</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Barometric Pressure">
                                        <td>Pressure</td>
                                        <td class="text-right">hPa</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Wind Speed">
                                        <td>Wind Speed</td>
                                        <td class="text-right">m/s</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Wind Direction">
                                        <td>Wind Direction</td>
                                        <td class="text-right">°</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                    <tr data-metric="Rainfall Sensor">
                                        <td>Rainfall</td>
                                        <td class="text-right">cm</td>
                                        <td class="text-right bg-subcontainer" data-station="MET 01">0</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- ✅ SECOND TABLE -->
                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <span class="iconify" data-icon="mingcute:performance-line"></span>
                            <h3>Met Stations - Signal Values</h3>
                            <div class="header-actions">
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge" data-inline="false"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body ref-table">
                        <div class="table-responsive">
                            <table class="has-min-width">
                                <thead>
                                    <tr>
                                        <th colspan="2"></th>
                                        <th>MET 01</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Ref. 1 VOC</td>
                                        <td class="text-right">V</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Ref. 1 VSHUNT</td>
                                        <td class="text-right">A</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Ref. 2 VOC</td>
                                        <td class="text-right">V</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                    <tr>
                                        <td>Ref. 2 VSHUNT</td>
                                        <td class="text-right">A</td>
                                        <td class="text-right bg-subcontainer">0</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- ✅ CHARTS WITH DATE PICKERS -->

                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Reference Cell POA Irradiance (W/m²)</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="refCellIrradianceChart_chart_display"></span>
                                <input type="hidden" id="refCellIrradianceChart_chart_start">
                                <input type="hidden" id="refCellIrradianceChart_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="refCellIrradianceChart_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="column-chart" id="refCellIrradianceChart">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Pyranometer Horizontal Irradiance (W/m²)</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="horizontalIrradianceChart_chart_display"></span>
                                <input type="hidden" id="horizontalIrradianceChart_chart_start">
                                <input type="hidden" id="horizontalIrradianceChart_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="horizontalIrradianceChart_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="column-chart" id="horizontalIrradianceChart">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Module Temperature (°C)</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="moduleTemperatureChart_chart_display"></span>
                                <input type="hidden" id="moduleTemperatureChart_chart_start">
                                <input type="hidden" id="moduleTemperatureChart_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="moduleTemperatureChart_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="column-chart" id="moduleTemperatureChart">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Wind Speed (m/s)</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="windSpeedChart_chart_display"></span>
                                <input type="hidden" id="windSpeedChart_chart_start">
                                <input type="hidden" id="windSpeedChart_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="windSpeedChart_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="column-chart" id="windSpeedChart">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-column">
                    <div class="column-header">
                        <div class="header-title has-icon">
                            <h3>Barometer Pressure (hPa)</h3>
                            <div class="header-actions d-flex align-center gap-10">
                                <span class="date-display" id="pressureChart_chart_ display"></span>
                                <input type="hidden" id="pressureChart_chart_start">
                                <input type="hidden" id="pressureChart_chart_end">
                                <button class="date-range-button" title="Select Date Range" id="pressureChart_chart_picker">
                                    <span class="iconify" data-icon="mdi:calendar-range"></span>
                                </button>
                                <button class="full-screen-button" title="Full Screen">
                                    <span class="iconify" data-icon="akar-icons:enlarge"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="container-body">
                        <div class="column-chart" id="pressureChart">
                            <div class="chart-type-toggle">
                                <select>
                                    <option value="lines">Line</option>
                                    <option value="markers">Scatter (Markers)</option>
                                    <option value="lines+markers">Line + Markers</option>
                                    <option value="bar">Bar</option>
                                    <option value="area">Area (Filled Line)</option>
                                    <option value="spline">Spline</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        `;
    }
}
